<app-top-navbar/>
<div class="wrapper page-recover-password">
  <app-loyalty-club-header/>
  <h3>{{ 'login.recover-password.set_new_password' | translate }}</h3>
  @if (isTokenCorrect) {
    @if (!isPasswordChanged) {
      <form
          [formGroup]="form"
          [class.submitted]="isSubmitted"
          (submit)="onFormSubmit()">
        <app-password formControlName="password"/>
        <div class="form-group text-center">
          <button class="btn btn-raised btn-primary">{{ 'login.recover-password.set_password' | translate }}
          </button>
          @if (setPasswordError) {
            <span>{{ 'login.recover-password.set_password_error' | translate }}</span>
          }
        </div>
      </form>
    }
    <ng-container>
      @if (isPasswordChanged) {
        <app-alert alertType="info">
          {{ 'login.recover-password.password_changed'  | translate }}
        </app-alert>
      }
    </ng-container>
  } @else {
    @if (isTokenCorrect === false) {
      <app-alert alertType="error">
        {{ 'login.recover-password.token_invalid_error' | translate }}
      </app-alert>
    }
  }
  @if ((isTokenCorrect === false) || isPasswordChanged) {
    <div class="form-group">
      @if ((isGaleriaDominikanskaActive$ | async)) {
        <a
            class="btn btn-raised btn-block btn-primary"
            href="https://galeria-dominikanska.pl/maszokazje/">
          <span>{{ 'generic.log_in' | translate }}</span> <i class="icon icon-sign-in"></i>
        </a>
      } @else {
        <button type="button" class="btn btn-raised btn-block btn-primary" (click)="gotoLoginPage()">
          <span>{{ 'generic.log_in' | translate }}</span> <i class="icon icon-sign-in"></i>
        </button>
      }
    </div>
  }
  <app-loyalty-club-footer/>
</div>
